module.exports = __webpack_public_path__ + "static/kwekkwek-7fec19581ff271b4fb033cd8cbc7defe.jpg";